import { createIcon } from '../createIcon';
import { ReactComponent as IconRemoveCircle } from '../svg/remove-circle.svg';

export default createIcon(IconRemoveCircle);
